module.exports = "img/26.06bbad.webp";